import { Box } from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import { ThemedLoadingAnimation } from './themed';
import { useVenueTypeHint } from '../../contexts/VenueContext';
import type { VenueTypeCode } from '../../features/landing/constants/venueTypes';

export const VendorLoadingFallback = () => {
  const hint = useVenueTypeHint();
  const venueType = hint as VenueTypeCode | undefined;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
      }}
    >
      {/*
       * AnimatePresence + motion.div provides a smooth fade-in entrance.
       * The exit animation (opacity: 0) fires when a persistent AnimatePresence
       * ancestor removes this node — e.g. if the Suspense boundary is wrapped
       * with AnimatePresence in the future. Without such a parent the exit prop
       * is a no-op but the entrance animation always works correctly.
       */}
      <AnimatePresence>
        <motion.div
          key="vendor-loading-fallback"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, delay: 0.1 }}
        >
          <ThemedLoadingAnimation venueType={venueType} />
        </motion.div>
      </AnimatePresence>
    </Box>
  );
};
